/* global module, require */
const THREE = require('three'),
	asBuffer = require('../asBuffer'),
	unit = require('../unit');

// TODO
const gBaseDiameter = unit.mm(80),
	gInnerSquash = 0.25;

const gBaseHeight = unit.mm(20),
	gBaseRadius = gBaseDiameter / 2,
	gConnectorDiameter = unit.mm(14),
	gConnectorHeight = unit.mm(67),
	gConnectorRadius = gConnectorDiameter / 2;

function getBaseHeight() {
	return gBaseHeight;
}

function getInnerHeight(totalHeight, tubeDiameter) {
	return (tubeDiameter / 2) * gInnerSquash;
}

function getRailHeight(totalHeight, tubeDiameter) {
	return (
		totalHeight - tubeDiameter - getInnerHeight(totalHeight, tubeDiameter) * 2
	);
}

function getTubeHeight(totalHeight, tubeDiameter) {
	return (
		totalHeight -
		tubeDiameter -
		getInnerHeight(totalHeight, tubeDiameter) -
		gConnectorHeight -
		gBaseHeight
	);
}

function getGeometry(tubeRadius, totalHeight) {
	const geo = new THREE.Geometry(),
		id = new THREE.Matrix4(),
		innerHeight = tubeRadius * gInnerSquash,
		start = gBaseHeight / 2,
		tubeHeight = getTubeHeight(totalHeight, tubeRadius * 2);

	const base = new THREE.CylinderGeometry(
			gBaseRadius,
			gBaseRadius,
			gBaseHeight
		).translate(0, start, 0),
		connector = new THREE.CylinderGeometry(
			gConnectorRadius,
			gConnectorRadius,
			gConnectorHeight
		).translate(0, start + tubeHeight + innerHeight + gConnectorHeight / 2, 0),
		inner = new THREE.SphereGeometry(tubeRadius)
			.scale(1, gInnerSquash, 1)
			.translate(0, start + tubeHeight, 0),
		tube = new THREE.CylinderGeometry(
			tubeRadius,
			tubeRadius,
			tubeHeight
		).translate(0, start + tubeHeight / 2, 0);
	geo.merge(base, id);
	geo.merge(connector, id);
	geo.merge(inner, id);
	geo.merge(tube, id);

	return asBuffer(geo);
}

module.exports = {
	getBaseHeight,
	getGeometry,
	getRailHeight,
	getTubeHeight,
};
